import { render, staticRenderFns } from "./AdBlockModal.vue?vue&type=template&id=0dcb608e&scoped=true&"
import script from "./AdBlockModal.vue?vue&type=script&lang=ts&"
export * from "./AdBlockModal.vue?vue&type=script&lang=ts&"
import style0 from "./AdBlockModal.vue?vue&type=style&index=0&id=0dcb608e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb608e",
  null
  
)

export default component.exports